document.addEventListener("DOMContentLoaded", async () => {

  const container = document.querySelector(".wishlist-grid");
  if (!container) return;

  const handles = JSON.parse(localStorage.getItem("wishlist_products")) || [];
  if (!handles.length) {
    container.innerHTML = "<p>No products in wishlist</p>";
    return;
  }

  for (let handle of handles) {
    const res = await fetch(`/products/${handle}.js`);
    const product = await res.json();

    container.innerHTML += `
      <div class="wishlist-item">
        <a href="${product.url}">
          <img src="${product.featured_image}" />
          <h3>${product.title}</h3>
        </a>
        <button data-wishlist="${handle}" class="wishlist-btn active">&#10084;</button>
      </div>
    `;
  }
});
